(function() {
    'use strict';

    angular
        .module('app')
        .directive('drvEntitySelectorViaTemplate', drvEntitySelectorViaTemplate);

    drvEntitySelectorViaTemplate.$inject = [];
    
    /**
     * @ngdoc directive
     * @name drvEntitySelectorViaTemplate
     *
     * @description
     * A component used for selecting an entity via two select controls, entity template and entity.
     *
     * # Scope Params
     * {string} label - The label/name to be shown for the control. Optional.
     * {bool} hideLabel - The label property is also used for setting the input name, however there may be times where the label itself should not be displayed to the user. Optional.
     * {bool} showOptionalSubscript - Show 'Optional' subscript after the label. Optional.
     * {number} selectedEntity - Id of entity which is currently selected
     * {number} selectedEntityTemplate - Entity template which is currently selected. Optional.
     * {bool} disabled - Disables the entity template and entity controls. Optional.
     * {bool} entityTemplateDisabled - Disables the entity template control. Optional.
     * {bool} mandatory - Value must be selected. Optional.
     */
    function drvEntitySelectorViaTemplate() {
        var directive = {
            restrict: 'E',
            controller: drvEntitySelectorViaTemplateCtrl,
            controllerAs: 'drvCtrl',
            bindToController: {
                label: '<?',
                hideLabel: '<?',
                showOptionalSubscript: '<?',
                selectedEntity: '=',
                selectedEntityTemplate: '=?',
                disabled: '<?',
                entityTemplateDisabled: '<?',
                mandatory: '<?'
            },
            transclude: true,
            template:
                '<div layout="row" layout-wrap>' +
                '<drv-hidden-input flex="100" name="drvCtrl.label" invalid="drvCtrl.invalid"></drv-hidden-input>' +
                '<span flex="100" class="material-label-fake" ng-class="{ mandatory: drvCtrl.mandatory, optional: drvCtrl.showOptionalSubscript }" ng-if="drvCtrl.label && !drvCtrl.hideLabel">{{drvCtrl.label}}</span>' +
                '<md-progress-linear md-mode="query" ng-show="drvCtrl.loading" flex="100"></md-progress-linear>' +
                '<div style="margin-right: 9px;" flex="" layout="row">' +
                '   <drv-icon usage="\'error\'" ng-if="drvCtrl.showError" drv-tool-tip="{{\'drvCtrl.error\'}}"></drv-icon>' +
                '   <drv-entity-template-selector flex="grow" disabled="drvCtrl.loading || drvCtrl.disabled || drvCtrl.entityTemplateDisabled" entity-templates="drvCtrl.entityTemplates" selected-entity-template="drvCtrl.selectedEntityTemplateId"  label="\' \'" place-holder="Select Item Type" value-properties="\'Id\'">' +
                '   </drv-entity-template-selector>' +
                '</div>' +
                '<drv-entity-selector style="margin-left: 9px;" flex="" disabled="drvCtrl.loading || drvCtrl.showError || drvCtrl.disabled" ng-model="drvCtrl.selectedEntity" entity-list="drvCtrl.entities" value-properties="\'Id\'" place-holder="{{drvCtrl.entityPlaceholder}}">' +
                '</drv-entity-selector>' +
                '</div>'
        };

        drvEntitySelectorViaTemplateCtrl.$inject = ['$scope', '$q', 'EntitiesService', 'EntityTemplatesService', 'ChilliUserProfileService'];

        return directive;

        function drvEntitySelectorViaTemplateCtrl($scope, $q, EntitiesService, EntityTemplatesService, ChilliUserProfileService) {
            /* jshint validthis:true */
            var drvCtrl = this;
            drvCtrl.loading = true;
            drvCtrl.entityTemplates = [];
            drvCtrl.entities = [];
            Object.defineProperty(drvCtrl, 'showError', { get: function () { return !_.isNil(drvCtrl.error); } });
            Object.defineProperty(drvCtrl, 'invalid', { get: function () { return (drvCtrl.selectedEntityTemplateId && !drvCtrl.selectedEntity) || (drvCtrl.mandatory && !drvCtrl.selectedEntity); } });
            Object.defineProperty(drvCtrl, 'invalidMessages', { get: getInvalidMessages });
            Object.defineProperty(drvCtrl, 'entityPlaceholder', { get: getEntityPlaceHolder });
            Object.defineProperty(drvCtrl, 'entityTemplateName', { get: getEntityTemplateName });

            activate();

            function activate() {

                loadEntityTemplates()
                    .then(function () {
                        drvCtrl.loading = false;

                        $scope.$watch('drvCtrl.selectedEntityTemplateId', function (newVal, oldVal) {
                            if (newVal !== oldVal) {
                                entityTemplateChanged();
                            }
                        });

                        $scope.$watch('drvCtrl.selectedEntity', function (newVal, oldVal) {
                            if (newVal !== oldVal) {
                                entityChanged();
                            }
                        });
                    });
            }

            /**
             * Loads all of the entity templates the current user has access to.
             */
            function loadEntityTemplates() {
                return EntityTemplatesService.query()
                    .then(getEntityTemplatesOk, getEntityTemplatesError);

                function getEntityTemplatesOk(data) {
                    drvCtrl.entityTemplates = [];

                    _.remove(data.EntityTemplates, { UserGranted: false });

                    if (!ChilliUserProfileService.userIsAdministrator) {
                        _.remove(data.EntityTemplates, function (entityTemplate) {
                            return !_.isNil(entityTemplate.EntityType) && entityTemplate.EntityType === 'Organisation';
                        });
                    }

                    drvCtrl.entityTemplates = _.sortBy(data.EntityTemplates, function (entityTemplate) { return entityTemplate.Name; });

                    if (!_.isNil(drvCtrl.selectedEntity)) {
                        return loadDefaultEntities()
                            .then(function () {
                            }, function () {
                                drvCtrl.error = 'Error fetching ' + drvCtrl.selectedEntityTemplate.PluralName;
                            });
                    }
                }

                function getEntityTemplatesError(response) {
                    drvCtrl.error = 'Error fetching entity templates';
                    drvCtrl.loading = false;
                }
            }

            /**
             * When an entity is selected without an entity template also being selected, it is assumed that it is for the initial load.
             * The entity data is retrieved and using the entity template id of this data, all entities for that entity template are loaded.
             */
            function loadDefaultEntities() {
                return EntitiesService.getPreviewText(drvCtrl.selectedEntity)
                    .then(getDefaultEntityOk, null);

                function getDefaultEntityOk(data) {
                    if (_.isNil(data)) {
                        return $q.reject();
                    } else {
                        return loadEntities(data.EntityTemplateId)
                            .then(function () {
                                drvCtrl.selectedEntityTemplate = _.find(drvCtrl.entityTemplates, function (entityTemplate) { return entityTemplate.Id === data.EntityTemplateId; });
                                drvCtrl.selectedEntityTemplateId = data.EntityTemplateId;
                                drvCtrl.selectedEntity = data.Id;
                            });
                    }
                }
            }


            /**
             * Loads all of the entities for the supplied entity template id.
             */
            function loadEntities(entityTemplateId) {
                var orderFields = [];
                var entityTemplate = _.find(drvCtrl.entityTemplates, function (entityTemplate) { return entityTemplate.Id === entityTemplateId; });
                if (!_.isNil(entityTemplate) && !_.isNil(entityTemplate.OrderSetting)) {
                    var defaultOrderOption = _.find(entityTemplate.OrderSetting.Options, function (option) { return option.Name === entityTemplate.OrderSetting.Default; });

                    if (!_.isNil(defaultOrderOption) && !_.isNil(defaultOrderOption.Fields)) {
                        orderFields = defaultOrderOption.Fields;
                    }
                }

                return EntitiesService.query({
                    entityTemplateId: entityTemplateId,
                    orderFields: orderFields
                })
                .then(getEntitiesOk, null);

                function getEntitiesOk(data) {
                    if (!ChilliUserProfileService.userIsAdministrator && !_.isNil(entityTemplate) && entityTemplate.EntityType === 'User') {
                        _.remove(data.Entities, function (entity) {
                            return entity.Id !== ChilliUserProfileService.userProfile.Id;
                        });
                    }

                    drvCtrl.entities = data.Entities;

                    return loadSelectedEntity();
                }
            }

            /*
             * Load the selected entity if it's not in the entity list. This can happen for logically deleted entities.
             */
            function loadSelectedEntity() {
                if (!_.isNil(drvCtrl.selectedEntity) && !_.some(drvCtrl.entities, function (entity) { return entity.Id === drvCtrl.selectedEntity; })) {
                    return EntitiesService.getPreviewText(drvCtrl.selectedEntity)
                        .then(loadSelectedEntityOk, null);
                }
            }

            function loadSelectedEntityOk(data) {
                drvCtrl.entities.push(data);
            }

            /**
             * When the entity template is changed the entities list and selected entity need to be updated
             */
            function entityTemplateChanged() {
                if (_.isNil(drvCtrl.selectedEntityTemplateId)) {
                    drvCtrl.entities = [];
                    drvCtrl.selectedEntityTemplate = null;
                } else {
                    drvCtrl.loading = true;
                    drvCtrl.selectedEntityTemplate = _.find(drvCtrl.entityTemplates, function (et) {
                        return et.Id === drvCtrl.selectedEntityTemplateId;
                    });

                    loadEntities(drvCtrl.selectedEntityTemplateId)
                        .then(function () {
                            if (!_.isNil(drvCtrl.selectedEntity) && !_.any(drvCtrl.entities, 'Id', drvCtrl.selectedEntity)) {
                                // Currently selected entity is no longer valid, deselect it
                                drvCtrl.selectedEntity = null;
                            }

                            drvCtrl.error = null;
                            drvCtrl.loading = false;
                        },
                        function () {
                            drvCtrl.error = 'Error fetching ' + drvCtrl.selectedEntityTemplate.PluralName;
                            drvCtrl.loading = false;
                        });
                }
            }

            /**
             * When the entity changed and no entity template is currently selected, it is assumed it's an intial 'default' entity and the appropriate entities will need to be loaded
             */
            function entityChanged() {
                if (!_.isNil(drvCtrl.selectedEntity)) {
                    if (_.isNil(drvCtrl.selectedEntityTemplateId)) {
                        loadDefaultEntities();
                    }
                }
            }

            /**
             * Get the messages which should be displayed if the selection is invalid
             *
             * @returns {array} Returns a list of messages describing why the selection is invalid
             */
            function getInvalidMessages() {
                var result = [];

                if (drvCtrl.selectedEntityTemplateId && !drvCtrl.selectedEntity) {
                    result.push('When a template is selected, ' + drvCtrl.entityTemplateName + ' must also be selected.');
                }

                if (drvCtrl.mandatory && !drvCtrl.selectedEntity) {
                    result.push(drvCtrl.entityTemplateName + ' is required.');
                }

                return result;
            }

            /**
             * Get the entity template name for the currently selected entity template
             *
             * @returns {string} Returns the entity template name
             */
            function getEntityTemplateName() {
                var result = 'Item';

                if (!_.isNil(drvCtrl.selectedEntityTemplate)) {
                    result = drvCtrl.selectedEntityTemplate.Name;
                }

                return result;
            }

            /**
             * Get the entity placeholder text to be shown in the entity autocomplete control
             *
             * @returns {string} Returns the placeholder text for the entity autocomplete.
             */
            function getEntityPlaceHolder() {
                return 'Select ' + getEntityTemplateName();
            }
        }
    }
})();